export enum PersonTypesEnum {
  natural = 'NATURAL',
  legal = 'LEGAL',
}
